<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        {{ $t('Filters')}}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >

          <label>{{ $t('Subject ') }}</label>
   
          <v-select
             multiple
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="subjectFilter"
            :options="subjectOptions"
            label="name"
            class="w-100"
            :clearable="true"
            :placeholder="$t('Filter BY subject')"
            :reduce="val =>(val.subject_id+','+val.type)"
            @input="(val) => {$emit('update:subjectFilter', val) }"
           
            v-on:input="reformatDasta()"
          />
        </b-col>


        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t('causer') }}</label>
          <v-select
          multiple
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="causerFilter"
              :clearable="true"
              :options="causerOptions"
              :placeholder="$t('Filter BY causer')"
              label="name"
              class="w-100"
              :reduce="val => val.id"
              @input="(val) => $emit('update:causerFilter', val)"
              v-on:input="reformatDasta()"
          />
        </b-col>


        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>{{ $t('event') }}</label>
      
          <v-select
          multiple
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="eventFilter"
              :clearable="true"
              :options="eventOptions.map((i)=>({id:i,name:i}))"
              :placeholder="$t('Filter BY event')"
              label="name"
              class="w-100"
              :reduce="val => val.id"
              @input="(val) => $emit('update:eventFilter', val)"
              v-on:input="reformatDasta()"
          />
        </b-col>


        <!-- <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>{{ $t('Name') }}</label>
          <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="nameFilter"
              :clearable="true"
              :options="nameOptions"
              :placeholder="$t('Filter BY name')"
              class="w-100"
              @input="(val) => $emit('update:nameFilter', val)"
          />
        </b-col> -->

    

          <b-col  md="3" sm="3">
            <!-- report range date -->
           
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder=" new Date()" 
                v-on:input="reformatDasta()"
                />

             
            </b-form-group>
          </b-col>
       


      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

global.jQuery = require('./jquery.min.js');
require('./jquery.json-viewer.js');
var $ = global.jQuery;

function res()  {

  setTimeout(function () {
    $('.jsondata').each(function (i) {

      this.style.color = "blue";

      var data = $(this).attr('data')

      $(this).jsonViewer(JSON.parse(data));
      $(this).addClass("foo");
    })

  }, 1000*5)


  //$('#json-renderer').jsonViewer(data);
};
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr,
    BFormGroup
  },
  props: {
    subjectOptions: {
      type: Array,
      required: true,
    },

    subjectFilter: {
        type: Array,
       default: [],
    },

    causerOptions: {
      type: Array,
      required: true,
    },
    causerFilter: {
      type: Array,
      default: [],
    },

    eventOptions: {
      type: Array,
      required: true,
    },
    eventFilter: {
      type: Array,
      default: [],
    },
    from:{type:String,default:""},
    to:{type:String,default:""},


    //  nameFilter: {
    //   name: [String, null],
    //   default: null,
    // },
    //  nameOptions: {
    //   type: Array,
    //   required: true,
    // },

      
  },

 
  setup(props,{emit}){
 const reformatDasta=()=>{
    res();

 }
     const rangeDate = ref('')
    const  pickerOptions ={
        dateFormat: 'Y-m-d H:i:S',
        defaultDate: [
          new Date().setHours(0,0,0),
          new Date().setHours(23, 59, 59, 59),
        ],
    
        enableTime: true,
        enableSeconds: true,
        defaultHour: 23,
        mode: 'range',
        time_24hr: true,
        onClose: function(selectedDates, dateStr, instance) {
          const date = dateStr.split(' to ')
         
          emit('update:to',  date[1])
          emit('update:from',  date[0])
        
       
          
        },
      }

      return {
        pickerOptions,
        rangeDate,
        reformatDasta
      }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
